import {
  Box,
  Drawer,
  DrawerContent,
  Spinner,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";

// Types
import { SidebarProps } from "./Sidebar.types";

// Components
import Tooltip from "components/Tooltip";
import Content from "./Content";
import MobileNav from "./MobileNav";

// Hooks
import useApp from "hooks/useApp";

const Sidebar = ({
  menuItems,
  extraItems,
  stakingOptions,
  showBanner,
  children,
  ...rest
}: SidebarProps) => {
  const { isTxnProcessing, openTxnHistoryModal } = useApp();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [isMobile] = useMediaQuery("(max-width: 768px)");

  return (
    <Box pt={showBanner ? (isMobile ? "104px" : "48px") : "0"}>
      <Content
        menuItems={menuItems}
        stakingOptions={stakingOptions}
        display={{ base: "none", xl: "block" }}
        onClose={() => onClose}
        {...rest}
      />
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
      >
        <DrawerContent
          overflow="auto"
          bg={{ base: "brand.backgroundLight", xl: "transparent" }}
        >
          <Content
            menuItems={menuItems}
            stakingOptions={stakingOptions}
            onClose={onClose}
            {...rest}
          />
        </DrawerContent>
      </Drawer>
      <MobileNav onOpen={onOpen} extraItems={extraItems} />
      <Box ml={{ base: 0, xl: 60 }} p="4">
        {children}
      </Box>
      {isTxnProcessing && (
        <Box
          p="1rem"
          borderRadius="50%"
          pos="fixed"
          right="2rem"
          bottom="2rem"
          bg="brand.textColor"
          zIndex="4"
          textAlign="center"
          onClick={openTxnHistoryModal}
          cursor="pointer"
        >
          <Tooltip
            label="Transactions in progress. Click to view!"
            placement="left"
          >
            <Spinner
              size="lg"
              color="brand.backgroundLight"
              verticalAlign="middle"
            />
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default Sidebar;
